export default __webpack_public_path__ + "static/media/video-gray-icon.db5aa72d.png";